import { useFragment } from 'react-relay/hooks'
import { graphql } from 'relay-runtime'
import { useAuthGate } from 'hooks/auth'
import { Fragment, memo, ReactElement, useMemo } from 'react'
import { AuthGate_User$key } from '__generated__/AuthGate_User.graphql'
import { Nullable } from 'types'
import PageBundlePlaceholder from './PageBundlePlaceholder'

interface IAuthGateProps {
  allowed: Nullable<boolean>
  userFragmentRef: Nullable<AuthGate_User$key>
  children?: any
  placeholder?: ReactElement
  redirectTo?: string
}

/**
 * Gate access to a page. This component will automatically redirect the user to their homepage if
 * the allowed prop is false.
 */
function AuthGate({ userFragmentRef, allowed, children, placeholder, redirectTo }: IAuthGateProps) {
  const user = useFragment(graphql`
    fragment AuthGate_User on User {
      ...auth_useAuthGate
    }
  `, userFragmentRef)

  const options = useMemo(() => ({ redirectTo }), [redirectTo])
  useAuthGate(user, Boolean(allowed), options)

  if (allowed) return <Fragment>{children}</Fragment>

  return placeholder || <PageBundlePlaceholder />
}

export default memo(AuthGate)
